import { render, staticRenderFns } from "./CandidateFavoritedIndicator.vue?vue&type=template&id=dae2d4ee&scoped=true"
import script from "./CandidateFavoritedIndicator.vue?vue&type=script&setup=true&lang=js"
export * from "./CandidateFavoritedIndicator.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CandidateFavoritedIndicator.vue?vue&type=style&index=0&id=dae2d4ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae2d4ee",
  null
  
)

export default component.exports